<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible"
    width="40%">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="80px">
    <div >
      <el-form-item  label="资金方" prop="userId">
        <div class="funding">
          <div style="width: 100%;">
            <el-select @change="selectFund()"  v-model="dataForm.userId" placeholder="请选择" filterable clearable style="width:100%">
              <el-option v-for="item in fundList" :key="item.userId" :label="item.deptName" :value="item.userId">
              </el-option>
            </el-select>
          </div>
        </div>
      </el-form-item>
    <el-form-item label="IP地址" prop="ipCidr">
      <el-input style="width: 100%;" v-model="dataForm.ipCidr" placeholder="支持IP、IP段或通配符"></el-input>
    </el-form-item>
    <el-form-item label="状态" prop="status">
      <div class="funding">
          <div>
           <el-select style="width: 100%;"  @change="selectstatus()" v-model="dataForm.status" placeholder="请选择">
            <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>  
          </div>
        </div>
    </el-form-item>
    <el-form-item label="备注" prop="remark">
      <el-input style="width: 100%;" v-model="dataForm.remark" placeholder="备注"></el-input>
    </el-form-item>
    </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data () {
      return {
        visible: false,
        fundList: [],
        statusList: [
          { value: 0, label: '失效' },
          { value: 1, label: '有效' }
        ],
        dataForm: {
          id: '',
          userId: '',
          ipCidr: '',
          status: '',
          remark: ''
        },
        dataRule: {
          userId: [
            { required: true, message: '用户ID不能为空', trigger: 'blur' }
          ],
          ipCidr: [
            { required: true, message: '支持IP、IP段或通配符不能为空', trigger: 'blur' }
          ],
          status: [
            { required: true, message: '1=生效,0=失效不能为空', trigger: 'blur' }
          ],
          remark: [
            { required: true, message: '备注不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    created () {
        this.$http.get('/sys/user/queryUserIdList').then(res=>{
        this.fundList = res.data.data
      })
    },
    methods: {
      init (id) {
        this.dataForm.id = id
        this.visible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          if (this.dataForm.id) {
            this.$http.get(`/system/ip/info/${this.dataForm.id}`)
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return this.$message.error(res.msg)
              }
              this.dataForm = {
                ...this.dataForm,
                ...res.data,
              }
           }).catch(() => {})
          }
        })
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            console.log(this.dataForm);
            this.$http[!this.dataForm.id ? "post" : "put"]
            (`/system/ip/${!this.dataForm.id ? 'save' : 'update'}`,
            this.dataForm)
            .then(({data}) => {
              if (data && data.code === 0) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.visible = false
                    this.$emit('refreshDataList')
                  }
                })
              } else {
                this.$message.error(data.msg)
              }
            })
          }
        })
      },
      selectFund() {
        this.dataForm.deptName = this.fundList.find(
          item => item.userId == this.dataForm.userId)
          .deptName
      },
      selectstatus() {
        this.dataForm.status = this.statusList.find(
          item => item.value == this.dataForm.status)
          .value
      }
    }
  }
</script>
